import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLOR, FUENTE } from './tokens';
import { RANGOS_RAPIDOS, fechaCorta } from './fechasReportes';

const estiloBoton = (activo) => ({
    fontFamily: FUENTE, fontSize: 13, fontWeight: activo ? 600 : 500, border: 'none', padding: '8px 16px', cursor: 'pointer',
    background: activo ? COLOR.negro : 'transparent', color: activo ? '#fff' : COLOR.grisTexto,
    transition: 'all 0.2s', borderRadius: '6px',
});

const estiloInput = {
    fontFamily: FUENTE, fontSize: 13, border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', height: 36, background: '#fff',
    outline: 'none', color: COLOR.negro, fontWeight: 500
};

export default function BarraPeriodo({ periodo, rangos = RANGOS_RAPIDOS }) {
    const {
        preset, elegirPreset, cambiarMes, nombreDelMesActual,
        desdeManual, setDesdeManual, hastaManual, setHastaManual,
        incluirFuturos, setIncluirFuturos, desde, hasta, vacio,
    } = periodo;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '16px', background: '#fff', padding: '12px 16px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: 'var(--shadow-sm)', textAlign: 'center' }}>
            
            <Typography sx={{ fontFamily: FUENTE, fontSize: 11, fontWeight: 700, color: COLOR.grisTexto, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                Período
            </Typography>

            {/* 1. Selector principal (Segmented Control) */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '4px', width: 'fit-content', margin: '0 auto' }}>
                {rangos.map((r) => (
                    <button key={r.id} type="button" onClick={() => elegirPreset(r.id)} style={estiloBoton(preset === r.id)}>
                        {r.label}
                    </button>
                ))}
            </Box>

            {/* 2. Selector secundario dependiendo del preset */}
            {preset === 'mes' && (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', background: '#f8fafc', padding: '6px 10px', borderRadius: '8px', border: '1px solid #e2e8f0', width: 'fit-content', minWidth: '300px', margin: '0 auto' }}>
                    <button type="button" onClick={() => cambiarMes(-1)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 18, color: COLOR.grisTexto, padding: '0 8px' }}>←</button>
                    <Typography sx={{ fontFamily: FUENTE, fontSize: 15, fontWeight: 600, color: COLOR.negro, textTransform: 'capitalize', width: '160px', textAlign: 'center' }}>
                        {nombreDelMesActual}
                    </Typography>
                    <button type="button" onClick={() => cambiarMes(1)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 18, color: COLOR.grisTexto, padding: '0 8px' }}>→</button>
                </Box>
            )}

            {preset === 'rango' && (
                <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', background: '#f8fafc', padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', width: 'fit-content', margin: '0 auto' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', textAlign: 'left' }}>
                        <Typography sx={{ fontFamily: FUENTE, fontSize: 12, fontWeight: 600, color: COLOR.grisTexto }}>Desde</Typography>
                        <input type="date" aria-label="Desde" value={desdeManual} style={estiloInput} onChange={(e) => setDesdeManual(e.target.value)} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', textAlign: 'left' }}>
                        <Typography sx={{ fontFamily: FUENTE, fontSize: 12, fontWeight: 600, color: COLOR.grisTexto }}>Hasta</Typography>
                        <input type="date" aria-label="Hasta" value={hastaManual} style={estiloInput} onChange={(e) => setHastaManual(e.target.value)} />
                    </Box>
                </Box>
            )}

            <Box sx={{ height: 1, background: '#e2e8f0' }} />

            {/* 3. Ajustes y Resumen */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', columnGap: '24px', rowGap: '6px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 10, fontFamily: FUENTE, fontSize: 14, fontWeight: 500, color: COLOR.negro, cursor: 'pointer' }}>
                    <input 
                        type="checkbox" 
                        checked={incluirFuturos} 
                        onChange={(e) => setIncluirFuturos(e.target.checked)} 
                        style={{ width: 18, height: 18, cursor: 'pointer', accentColor: COLOR.negro }} 
                    />
                    Incluir turnos futuros
                </label>

                <Typography sx={{ fontFamily: FUENTE, fontSize: 14, fontWeight: 500, color: vacio ? COLOR.ambar : COLOR.grisTexto }}>
                    {vacio
                        ? 'Activá "Incluir turnos futuros" para ver este período.'
                        : desde || hasta
                            ? `${fechaCorta(desde)} — ${fechaCorta(hasta)}`
                            : 'Todo el histórico'}
                </Typography>
            </Box>
        </Box>
    );
}
